import { render, staticRenderFns } from "./configuration-automation-grossing-shelf-immediate-shelf-priority-modal.vue?vue&type=template&id=6d0e55f8&scoped=true&"
import script from "./configuration-automation-grossing-shelf-immediate-shelf-priority-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-grossing-shelf-immediate-shelf-priority-modal.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-grossing-shelf-immediate-shelf-priority-modal.scss?vue&type=style&index=0&id=6d0e55f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0e55f8",
  null
  
)

export default component.exports